import AdditionalSections from "app/pages/FicheProduit/components/AdditionalSections/AdditionalSections";
import PropTypes from "prop-types";
import { memo } from "react";

const SectionsList = ({ sections = [] }) => {
	return (
		<>
			{sections.map(section => (
				<AdditionalSections
					key={section.type ?? section.headline}
					headline={section.headline}
					blocks={section.blocks}
					moreDetails={section.moreDetails}
				/>
			))}
		</>
	);
};

SectionsList.propTypes = {
	sections: PropTypes.array.isRequired,
};

export default memo(SectionsList);
